export default {
  root: {
    class: [
      'inline-flex items-center',
      'px-3 py-1',
      'rounded-[1.14rem]',
      'font-medium',
      'text-primary-highlight-inverse bg-primary-highlight',
    ],
  },
  label: {
    class: 'leading-6 m-0',
  },
  icon: {
    class: 'leading-6 mr-2',
  },
  image: {
    class: ['w-8 h-8 -ml-2 mr-2', 'rounded-full'],
  },
  removeIcon: {
    class: [
      'rounded-md leading-6',
      'ml-[0.375rem]',
      'w-4 h-4',
      'transition duration-200 ease-in-out',
      'cursor-pointer',
    ],
  },
}
